import { render, staticRenderFns } from "./BudgetManagement.vue?vue&type=template&id=2a15c5a2&scoped=true"
import script from "./BudgetManagement.vue?vue&type=script&lang=js"
export * from "./BudgetManagement.vue?vue&type=script&lang=js"
import style0 from "./BudgetManagement.vue?vue&type=style&index=0&id=2a15c5a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a15c5a2",
  null
  
)

export default component.exports